import { dew as _getActionDew } from "../../utils/getAction.js";
import { dew as _getBlockNumberDew } from "./getBlockNumber.js";
import { dew as _getTransactionDew } from "./getTransaction.js";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.getTransactionConfirmations = void 0;
  const getAction_js_1 = _getActionDew();
  const getBlockNumber_js_1 = _getBlockNumberDew();
  const getTransaction_js_1 = _getTransactionDew();
  async function getTransactionConfirmations(client, {
    hash,
    transactionReceipt
  }) {
    const [blockNumber, transaction] = await Promise.all([(0, getAction_js_1.getAction)(client, getBlockNumber_js_1.getBlockNumber, "getBlockNumber")({}), hash ? (0, getAction_js_1.getAction)(client, getTransaction_js_1.getTransaction, "getBlockNumber")({
      hash
    }) : undefined]);
    const transactionBlockNumber = transactionReceipt?.blockNumber || transaction?.blockNumber;
    if (!transactionBlockNumber) return 0n;
    return blockNumber - transactionBlockNumber + 1n;
  }
  exports.getTransactionConfirmations = getTransactionConfirmations;
  //# sourceMappingURL=getTransactionConfirmations.js.map
  return exports;
}